import React, { useState } from 'react';
import { FiSearch, FiMapPin, FiX, FiLayers } from 'react-icons/fi';
import './FilterBar.css';

function FilterBar({ onFilterChange, datasets = [], selectedDataset = '', onDatasetChange }) {
  const [search, setSearch] = useState('');
  const [location, setLocation] = useState('');

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearch(value);
    onFilterChange({ search: value, location });
  };

  const handleLocationChange = (e) => {
    const value = e.target.value;
    setLocation(value);
    onFilterChange({ search, location: value });
  };

  const handleClear = () => {
    setSearch('');
    setLocation('');
    onFilterChange({ search: '', location: '' });
  };

  const totalDatasetCount = datasets.reduce((sum, d) => sum + d.count, 0);

  return (
    <div className="filter-bar">
      {/* Dataset selector */}
      {datasets.length > 0 && (
        <div className="filter-group dataset-group">
          <FiLayers size={15} className="filter-icon" />
          <select
            className="filter-input dataset-select"
            value={selectedDataset}
            onChange={e => onDatasetChange(e.target.value)}
          >
            <option value="">All Datasets ({totalDatasetCount.toLocaleString()})</option>
            {datasets.map(d => (
              <option key={d.source_file} value={d.source_file}>
                {d.source_file} ({d.count.toLocaleString()})
              </option>
            ))}
          </select>
        </div>
      )}

      <div className="filter-group">
        <FiSearch size={15} className="filter-icon" />
        <input
          type="text"
          placeholder="Search by name or email..."
          value={search}
          onChange={handleSearchChange}
          className="filter-input"
        />
      </div>

      <div className="filter-group">
        <FiMapPin size={15} className="filter-icon" />
        <input
          type="text"
          placeholder="Filter by location..."
          value={location}
          onChange={handleLocationChange}
          className="filter-input"
        />
      </div>

      {(search || location) && (
        <button className="btn-clear" onClick={handleClear}>
          <FiX size={14} />
          Clear
        </button>
      )}
    </div>
  );
}

export default FilterBar;
